import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { FigureLogo, Phone, RoundedHamburger } from '../../svg';
import { COLORS, TYPOGRAPHY_CLASSNAMES, BREAKPOINTS_EM } from '../../../themes';
import Divider from '../../deprecated/Divider';
import { cssByBreakpoint, flex, focus, focusStyles } from '../../../styling';
import StyledContainer from '../../Styled/StyledContainer';
import { useWindowEvent } from '../../../hooks';
import { SPACE, IS_DEV, IS_STAGING } from '../../../constants';
import LinkOrButton from '../../LinkOrButton';
var HeaderContainer = /*#__PURE__*/styled(StyledContainer).withConfig({
  displayName: "Header__HeaderContainer",
  componentId: "sc-15mim2-0"
})(["max-width:128.4rem;", ";justify-content:space-between;", ";"], flex('space-between', 'stretch'), cssByBreakpoint([css(["margin:0 auto;background-color:", ";padding:2rem;"], COLORS.WHITE), css(["background-color:", ";", ";padding-left:4rem;padding-right:4rem;"], COLORS.BACKGROUND_1, flex('space-between', 'stretch'))], [BREAKPOINTS_EM.SM]));
var TelLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "Header__TelLink",
  componentId: "sc-15mim2-1"
})(["color:", ";font-size:1.3rem;white-space:nowrap;text-decoration:none;margin:0;outline:none;vertical-align:middle;display:inline-block;padding-left:0.7rem;&:hover,&:focus{text-decoration-color:currentcolor;text-decoration-line:underline;}"], COLORS.NEUTRAL_500);
var MenuContainer = /*#__PURE__*/styled.section.withConfig({
  displayName: "Header__MenuContainer",
  componentId: "sc-15mim2-2"
})(["", ";", ";"], flex('flex-start', 'stretch'), cssByBreakpoint([css(["height:auto;"]), css(["height:3.6rem;"])]));
var QuestionContainer = /*#__PURE__*/styled.section.withConfig({
  displayName: "Header__QuestionContainer",
  componentId: "sc-15mim2-3"
})(["", " padding-top:0.6rem;padding-bottom:0.6rem;"], cssByBreakpoint([css(["display:none;"]), css(["", ";"], flex('flex-start', 'stretch'))]));
var MenuButtonContainer = /*#__PURE__*/styled.section.withConfig({
  displayName: "Header__MenuButtonContainer",
  componentId: "sc-15mim2-4"
})(["color:", ";", ";", ";position:relative;"], COLORS.PRIMARY_600, flex('flex-start', 'stretch'), cssByBreakpoint([css(["padding:0;"]), css(["padding-top:0.6rem;padding-bottom:0.6rem;"])]));
var MenuText = /*#__PURE__*/styled.p.withConfig({
  displayName: "Header__MenuText",
  componentId: "sc-15mim2-5"
})(["margin:0;color:", ";padding-left:2.4rem;font-weight:700;", ""], COLORS.PRIMARY_600, cssByBreakpoint([css(["display:none;"]), css(["display:block;"])]));
var DropdownMenu = /*#__PURE__*/styled.ul.withConfig({
  displayName: "Header__DropdownMenu",
  componentId: "sc-15mim2-6"
})(["padding:0;margin:0;list-style:none;width:100%;z-index:50;box-shadow:0px 10px 0px rgba(0,0,0,0.14);transform:scale(", ");position:absolute;top:2.5rem;right:0;width:auto;min-width:170px;box-shadow:-10px 10px 0px rgba(0,0,0,0.14);"], function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 1 : 0;
});
var DropdownItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "Header__DropdownItem",
  componentId: "sc-15mim2-7"
})(["color:", ";background-color:", ";font-size:1.2rem;font-weight:700;a,button,span{color:", ";cursor:pointer;display:block;font-size:1.2rem;font-weight:700;padding:13px;border:1px solid transparent;background-color:transparent;text-decoration:none;text-align:left;width:100%;outline:none;&:hover{text-decoration-color:currentcolor;text-decoration-line:underline;}&[data-focus-visible-added]:focus{outline-offset:-4px;}}"], COLORS.PRIMARY_700, COLORS.NEUTRAL_200, COLORS.PRIMARY_700);
var ButtonContainer = /*#__PURE__*/styled(StyledContainer).withConfig({
  displayName: "Header__ButtonContainer",
  componentId: "sc-15mim2-8"
})(["", " ", ";cursor:pointer;"], cssByBreakpoint([css(["display:block;"]), css(["", ";"], flex('flex-start'))]), focus(focusStyles));

var _ref3 = /*#__PURE__*/React.createElement(FigureLogo, null);

var _ref4 = /*#__PURE__*/React.createElement(Phone, null);

var _ref6 = /*#__PURE__*/React.createElement(RoundedHamburger, null);

var _ref7 = /*#__PURE__*/React.createElement(MenuText, null, "Menu");

export var Header = function Header(_ref2) {
  var children = _ref2.children,
      $css = _ref2.$css,
      className = _ref2.className,
      _ref2$menuList = _ref2.menuList,
      menuList = _ref2$menuList === void 0 ? [] : _ref2$menuList,
      _ref2$phoneNumber = _ref2.phoneNumber,
      phoneNumber = _ref2$phoneNumber === void 0 ? "1-888-819-6388" : _ref2$phoneNumber,
      _ref2$linkDescription = _ref2.linkDescription,
      linkDescription = _ref2$linkDescription === void 0 ? " go to homepage" : _ref2$linkDescription,
      _ref2$showContactInfo = _ref2.showContactInfo,
      showContactInfo = _ref2$showContactInfo === void 0 ? true : _ref2$showContactInfo;
  var toggleRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleWindowClick = useCallback(function (e) {
    var _toggleRef$current;

    var target = e.target;

    if (!((_toggleRef$current = toggleRef.current) !== null && _toggleRef$current !== void 0 && _toggleRef$current.contains(target)) && isOpen) {
      setIsOpen(false);
    }
  }, [isOpen]);
  var toggleOpen = useCallback(function () {
    setIsOpen(function (open) {
      return !open;
    });
  }, []);
  useWindowEvent('click', handleWindowClick); // TODO: make logo generic
  // TODO: make url generic

  return /*#__PURE__*/React.createElement(HeaderContainer, {
    $css: $css,
    className: className,
    as: "header",
    role: "banner"
  }, /*#__PURE__*/React.createElement(LinkOrButton, {
    visuallyHiddenText: linkDescription,
    href: "https://".concat(IS_DEV || IS_STAGING ? 'test' : 'www', ".figure.com/"),
    $css: css(["", ";"], cssByBreakpoint([css(["padding:0;"]), css(["padding-top:0.6rem;padding-bottom:0.6rem;"])]))
  }, _ref3), children, /*#__PURE__*/React.createElement(MenuContainer, null, showContactInfo && /*#__PURE__*/React.createElement(QuestionContainer, {
    className: TYPOGRAPHY_CLASSNAMES.M
  }, _ref4, /*#__PURE__*/React.createElement(TelLink, {
    href: "tel:".concat(phoneNumber)
  }, "Have a question? ", phoneNumber)), !!menuList.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    vertical: true,
    $css: css(["margin-bottom:0;margin-left:24px;margin-right:24px;", ""], cssByBreakpoint([css(["display:none;"]), css(["display:block;"])]))
  }), /*#__PURE__*/React.createElement(MenuButtonContainer, {
    ref: toggleRef,
    className: TYPOGRAPHY_CLASSNAMES.S_BOLD,
    as: "nav"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    onKeyUp: function onKeyUp(_ref5) {
      var key = _ref5.key,
          keyCode = _ref5.keyCode;
      var theKey = key || keyCode;

      if (SPACE.includes(theKey)) {
        toggleOpen();
      }
    },
    onClick: function onClick() {
      return setIsOpen(function (open) {
        return !open;
      });
    },
    tabIndex: 0
  }, _ref6, _ref7), /*#__PURE__*/React.createElement(DropdownMenu, {
    isOpen: isOpen,
    "aria-hidden": !isOpen
  }, menuList.map(function (menuItem, index) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      key: "menu-item-".concat(index)
    }, menuItem);
  }))))));
};
export default Header;